/* This File is for {purpose} */

<template>
  <apexchart
    width="100%"
    height="300px"
    type="bar"
    :options="options"
    :series="series"
  ></apexchart>
</template>

<script>
export default {
  name: "BarChart",
  data: () => ({
    options: {
      chart: {
        id: "vuechart-example",
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "July",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
    },
    series: [
      {
        name: "series-1",
        data: [30, 40, 45, 50, 49, 60, 70, 91, 53, 75, 64, 83],
      },
    ],
  }),
};
</script>

<style scoped></style>
